<template>
  <app-dropdown-button
    v-if="isCurrentUserPm || currentUserRights.canAddQuestions"
    data-locator="question-answer-add-menu"
    :menu-items="menuItems"
    :disabled="isQuestionsLimitReached"
  >
    <template #left-icon>
      <app-material-icon
        name="add_2"
        color="inherit"
      />
    </template>
    {{ $t('project.question-answer.QuestionAnswerTopBar.add') }}
  </app-dropdown-button>
</template>

<script>
  import { mapGetters } from 'vuex'

  import excelCustom from '@/assets/img/icons/excel_custom.svg'
  import { QUESTION_ANSWER_ADD_ROUTE_NAME } from '@/router/routerData'

  export default {
    name: 'QuestionAnswerTopBarAdd',
    data () {
      return {
        QUESTION_ANSWER_ADD_ROUTE_NAME,
        menuItems: [
          {
            title: this.$t('project.question-answer.QuestionAnswerTopBar.newQuestion'),
            action: () => { this.addNewQuestion() },
            icon: 'add_2',
            locatorValue: 'add-question-menu-item',
          },
          {
            title: this.$t('project.question-answer.QuestionAnswerTopBar.importQuestionsAndAnswers'),
            action: () => { this.openImportDialog() },
            img: excelCustom,
            locatorValue: 'question-answers-import-menu-item',
          },
        ],
      }
    },
    computed: {
      ...mapGetters('room', ['isCurrentUserPm', 'currentUserRights']),
      ...mapGetters('questionAnswer', ['isQuestionsLimitReached']),
    },
    methods: {
      addNewQuestion () {
        this.$router.push({ name: QUESTION_ANSWER_ADD_ROUTE_NAME })
      },
      openImportDialog () {
        this.$emit('open-import-excel-dialog')
      },
    },
  }
</script>
